var $ad55787d78970cf1$exports = {};
$ad55787d78970cf1$exports = {
    "pending": `nere\u{161}eno`
};


export {$ad55787d78970cf1$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
